import React, { useContext, useMemo } from 'react';

import packageJson from '../../../../../package.json';

import { CurrentPageContext, HistoryStackContext } from 'app/home/general-components/HistoryStackContext';
import { LocalizationContext } from 'app/localization/Context';
import { OTAType, useOTAReportPage } from '../device/deivce-detail/OTAReport';
import { ConnectionStatusValues } from 'app/home/home-components/connection-status/ConnectionStatus';
import CustomIconBack from 'app/home/home-components/CustomIconBack';

import { ReactComponent as IconBack } from 'images/general/back.svg';
import { ReactComponent as IconCall } from 'images/setting/support-call.svg';
import { ReactComponent as IconWebsite } from 'images/setting/support-website.svg';
// import { ReactComponent as IconRepeat } from 'images/general/repeat.svg';
// import { ReactComponent as IconRepeatDark } from 'images/general/repeat-dark.svg';
// import { ReactComponent as IconTick } from 'images/general/tick.svg';
import { ReactComponent as IconDownload } from 'images/general/download.svg';

import iconLicenses from 'licence-notice/icon.txt.js';
import webappLicenses from 'licence-notice/webapp.txt.js';

import './About.scss'

export default function About({ gateway, swController }) {
    const hs = useContext(HistoryStackContext);
    const p = useContext(CurrentPageContext);
    const dismissHandler = p.dismiss;

    const l = useContext(LocalizationContext);
    const s = l.strings;

    const showHubsVersion = (gateway.connectionStatus === ConnectionStatusValues.stable) && (!gateway.negotiatedProtocol.isSolo);
    const gwUpdateInfo = gateway.gwUpdateInfo;
    const isNewerVersionAvailable = (
        (gwUpdateInfo.isUpdateNotificationSupported === false) ||
        (gwUpdateInfo.isNewerVersionAvailable)
    );
    const canOTAHubFromClient = (
        (gateway.currentUser.permissions.setting) &&
        (gateway.negotiatedProtocol.canOTAHubFromClient) &&
        (gwUpdateInfo.canUpdateFromClient === true)
    );
    // const highlightVersionUpdate = (
    //     (gwUpdateInfo.updateSeverityLevel === 2) || (gwUpdateInfo.updateSeverityLevel === 3)
    // );

    const startOTA = useOTAReportPage(gateway.otaProgressController, OTAType.hub, undefined);

    const [versionText, versionEnvText] = useMemo(() => {
        if (gwUpdateInfo.currentVersionName) {
            if (gwUpdateInfo.currentVersionName.split) {
                let vv = gwUpdateInfo.currentVersionName.split("-");
                if (vv.length > 1) {
                    return [vv[1], vv[0].toLowerCase()];
                }
            }
        }
        return ["", ""];
    }, [gwUpdateInfo.currentVersionName]);

    // "/settings/app_settings"

    return (
        <div className="about-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="about-page-content">
                <CustomIconBack className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />
                <div className="header">{s.about}</div>

                <div className="card" onClick={() => { hs.push("/settings/about/support"); }}>
                    <div className="title">{s.support}</div>
                    <div />
                    <IconBack className="next-icon" />
                </div>

                <div className="card" onClick={() => { hs.push("/settings/about/licenses"); }}>
                    <div className="title">{s.opensourceLicenses}</div>
                    <div />
                    <IconBack className="next-icon" />
                </div>

                {
                    showHubsVersion ? (
                        isNewerVersionAvailable ? (
                            canOTAHubFromClient ? (
                                // <div className={"version-update-card " + (highlightVersionUpdate ? "highlight" : "")}
                                //     onClick={() => startOTA()}>
                                //     <div className="title">{s.hubVersionNewVersion}</div>
                                //     <div className="title2">{s.newVersionTapToUpdate}</div>
                                //     {
                                //         highlightVersionUpdate ?
                                //             <IconRepeatDark className="icon" /> :
                                //             <IconRepeat className="icon" />
                                //     }
                                // </div>
                                <div className="version-info-card">
                                    <div className="title">{s.hubVersion}</div>
                                    <div className="info">
                                        {s.newVersionInfo}
                                    </div>
                                    <div className="version-box">
                                        <div className="version">
                                            {versionText}
                                        </div>
                                        <div className="env">
                                            {versionEnvText}
                                        </div>
                                    </div>
                                    <div className="button-border" onClick={() => startOTA()}>
                                        <div className="label">{s.newVersionTapToUpdate}</div>
                                        <IconDownload className="icon" />
                                    </div>
                                </div>
                            ) : (
                                <div className="version-info-card">
                                    <div className="title">{s.hubVersion}</div>
                                    <div className="info highlight">
                                        {
                                            ((!gateway.negotiatedProtocol.canOTAHubFromClient) || (gwUpdateInfo.canUpdateFromClient !== true)) ?
                                                s.updateNotification.nonOTAMessage :
                                                s.updateNotification.nonAdminMessage
                                        }
                                    </div>
                                    <div className="version-box">
                                        <div className="version">
                                            {versionText}
                                        </div>
                                        <div className="env">
                                            {versionEnvText}
                                        </div>
                                    </div>
                                </div>
                            )
                        ) : (
                            <div className="version-info-card">
                                <div className="title">{s.hubVersion}</div>
                                <div className="info">
                                    {s.hubVersionUpToDateInSetting}
                                </div>
                                <div className="version-box">
                                    <div className="version">
                                        {versionText}
                                    </div>
                                    <div className="env">
                                        {versionEnvText}
                                    </div>
                                </div>
                            </div>
                        )) : null
                }

                <div className="version-info-card">
                    <div className="title">{s.clientVersion}</div>
                    <div className="info">
                        {s.clientVersionUpToDateInSetting}
                    </div>
                    <div className="version-box"
                        onClick={() => {
                            hs.push("/settings/app_settings");
                        }}>
                        <div className="version">
                            {packageJson.version}
                        </div>
                        <div className="env">
                            {packageJson.serverName}
                        </div>
                    </div>
                    {
                        swController.updateIsReady ? (
                            <div className="button-border" onClick={swController.reloadForUpdate}>
                                <div className="label">{s.newVersionTapToUpdate}</div>
                                <IconDownload className="icon" />
                            </div>
                        ) : null
                    }

                </div>
            </div>
        </div>
    )
}

export function SupportPage() {
    const p = useContext(CurrentPageContext);
    const dismiss = p.dismiss;

    const l = useContext(LocalizationContext);
    const s = l.strings;

    return (
        <div className="about-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="about-page-content">
                <CustomIconBack className="nav-icon" /> <div className="nav-button" onClick={dismiss} />
                <div className="header">{s.support}</div>

                <div className="support-info">
                    <IconCall className="icon" />
                    <div className="info">
                        {l.localizeNumber("021-88079975")}
                    </div>
                </div>

                <div className="support-info">
                    <IconWebsite className="icon" />
                    <div className="info">
                        www.Hinava.com
                    </div>
                </div>
            </div>
        </div>
    )
}

export function LicensesPage() {
    const p = useContext(CurrentPageContext);
    const dismiss = p.dismiss;

    const l = useContext(LocalizationContext);
    const s = l.strings;

    return (
        <div className="about-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="about-page-content">
                <CustomIconBack className="nav-icon" /> <div className="nav-button" onClick={dismiss} />
                <div className="header">{s.opensourceLicenses}</div>

                <div style={{
                    whiteSpace: "pre",
                    color: "#ffffff",
                    fontSize: 10,
                    overflow: "auto"
                }} dir="ltr">
                    {iconLicenses}
                    {webappLicenses}
                </div>
            </div>
        </div>
    )
}
